import { Injectable } from '@angular/core';

import { ArticleModel } from '@modules/article/models/article.model';

import { RichSnippet, RichSnippetAdapter } from '../interface/rich-snippet.interface';

import { BaseRichSnippetAdapter } from './base-rich-snippet.adapter';

@Injectable({
  providedIn: 'root',
})
export class ArticleAdapter extends BaseRichSnippetAdapter implements RichSnippetAdapter {
  adapt(data: ArticleModel): RichSnippet {
    const imageId =
      data.headerImage?.original?.id || (data.images && data.images.length > 0 ? data.images[0].id : undefined);
    const langCodes = data.slugs?.map((slug) => slug.lang) || [];

    return {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: this.truncateHeadline(data.title),
      description: this.extractDescription(data.content),
      articleBody: this.stripHtml(data.content),
      thumbnail: this.generateThumbnailsFromImage(imageId),
      availableLanguage: this.mapLanguageCodes(langCodes),
      datePublished: data.displayDate,
      author: this.getDefaultAuthor(),
    };
  }
}
